import DependenciesPage from './dependenciesPage.view';

export default DependenciesPage;
